export default {
  instances: state => state.instances,
  selectedInstance: state => state.selectedInstance,
  selectedInstanceObject: state => state.selectedInstanceObject,
  refreshInstancesObject: state => state.refreshInstancesObject,
  chosenInstances: state => state.chosenInstances,
  chosenInstanceIds: state => state.chosenInstances.map((instance) => { return instance.id })
}
